import { render, staticRenderFns } from "./NpRecognitionReport.vue?vue&type=template&id=0d5f9b58"
import script from "./NpRecognitionReport.vue?vue&type=script&lang=js"
export * from "./NpRecognitionReport.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionReport.vue?vue&type=style&index=0&id=0d5f9b58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports